document.addEventListener('DOMContentLoaded', (event) => {
    let ssStore = [
        "J G EMPORIUM",
        "J M LEECH BENDIGO - STORE 1",
        "LUC HOMEWARES & DESIGN",
        "NORTH EAST JEWELLERS",
        "NOVA JEWELLERY",
        "PALMERSTON JEWELLERS",
        "PHINC",
        "RUTHERFORD JEWELLERY",
        "SASSANO'S JEWELLERS",
        "VICTORIA LILY",
        "VICTORIA LILY - BRIGHT",
        "BALLANTYNES SHOWCASE JEWELLERS",
        "FLO & FRANKIE",
        "GMW JEWELLERY",
        "GOLD 'N' GIFTS",
        "GOLDSACK & CO LTD",
        "JEFF HONEYBUN JEWELLERS",
        "MOLYNEUX JEWELLERS",
        "PAUL TAYLOR JEWELLERS",
        "STUDIO 18 JEWELLERY",
        "THE RINGMAKERS",
        "7- DEGREE & CO",
        "COCOWILLOW",
        "HARVEYS JEWELLERS",
        "KADIA JEWELLERY",
        "LURENE JEWELLERS",
        "MANLY JEWELLERS",
        "NIK NAK",
        "PETER O'NEILL JEWELLERY",
        "PIPPIN CO",
        "REGENCY JEWELLERS ORANGE (STORE 5)",
        "ROBBS JEWELLERS",
        "ROCKS N RINGS JEWELLERS",
        "STAPLETON JEWELLERS",
        "PROUDS Fiji",
        "THE JEWELLERY AFFAIR",
        "ATLAS JEWELLERS ORAN PARK",
        "CARATI JEWELLERS ROUSE HILL",
        "DIMITRIES JEWELLERS - QUEANBEYAN",
        "DONE USE - SPEIRS JEWELLERS",
        "ELLYSE JEWELLERS",
        "EVANS JEWELLERY NARELLAN",
        "GOLD CITY JEWELLERS",
        "JIPSI CARTEL",
        "MAISY AND CO",
        "MARTINS JEWELLERS",
        "NOUR JEWELLERS",
        "PATRICO JEWELLERS",
        "PENNA'S EDENSOR PARK PHARMACY",
        "SPEIRS JEWELLERS",
        "STERLING JEWELLERS",
        "SUZIE ANDERSON HOME",
        "TETAS PTY LTD T/A STERLING JEWELLERS",
        "WATCH DIRECT",
        "ALLAN BROS SHOWCASE JEWELLERS",
        "BLIZZARDS",
        "BULMERS GIFT SALON",
        "BULMERS GIFT SALON - BAIRNSDALE",
        "BULMERS GIFT SALON - SALE",
        "D'ARTAGNAN",
        "DENILIQUIN JEWELLERS",
        "GOOD FOOD EMPORIUM",
        "IAN PATTISON JEWELLERS",
        "JOHN WOHLERS JEWELLERS",
        "KENNEDY'S SHOWCASE JEWELLERS",
        "LAZY FROG GIFTS",
        "NOONAN'S SHOWCASE JEWELLERS",
        "TATIAR PTY LTD",
        "TUNSTALL NEWS & LOTTO",
        "WISHARTS THE JEWELLERS",
        "YARRAWONGA SHOWCASE JEWELLERS",
        "BLACKBOX JEWELLERS - CAROUSEL",
        "BLACKBOX JEWELLERS - KARRINYUP",
        "BURROWS JEWELLERS",
        "CHEEKY SQUIRREL",
        "CITY OF GOLD JEWELLERS",
        "CREATIONS JEWELLERY",
        "FACET JEWELLERS - CLOVERDALE",
        "FACET JEWELLERS - SUCCESS",
        "FIRST AVENUE",
        "GRAHAMS ONLINE",
        "HAMMERSTRUCK JEWELLERS",
        "HOUSE OF GOLD",
        "HUNT & GATHER HOME",
        "INKAS JEWELLERS",
        "MAZINS DIAMOND JEWELLERS BUNBURY",
        "JEWELLERY@65",
        "LEON BAKER JEWELLERS",
        "LEON BAKER JEWELLERS - MERREDIN",
        "MCCREEDS CLASSIQUE JWLRS",
        "MJ GELDART DESIGNER JEWELLER",
        "OCEANNIA JEWELS",
        "PROSSER & CO MANUFACTURING JEWELLERS",
        "RUFFELL JEWELLERS ROBE",
        "SHOWCASE JEWELLERS NORTHAM",
        "SWALES JEWELLERS",
        "AUREALIS JEWELLERY",
        "BRAD KEARTON JEWELLERS",
        "CHINCHILLA JEWELLERS",
        "COCOWILLOW - TWEED HEADS",
        "COVER ME IN JEWELS",
        "DM JEWELLERS",
        "EMERALD FINE JEWELLERY",
        "FIERA BOUTIQUE",
        "FOREVER JEWELLERY",
        "GEM-ARRAY JEWELLERS",
        "H & S JEWELLERS",
        "HALLS JEWELLERS",
        "LAKE KAWANA JEWELLERS",
        "LESKES JEWELLERS",
        "L'DREAM",
        "LORRAE JEWELLERS",
        "LUCIANO'S LEADING EDGE JEWELLERS",
        "REGAL DESIGN JEWELLERY",
        "RHIA JEWELLERS",
        "SPRINGFIELD JEWELLERS",
        "UNDERWOOD JEWELLERS"
    ];
    
    let fkStore = [
        "GEMS & JEWELS",
        "STAFFORDS JEWELLERY",
        "BELLORO FINE JEWELLERY",
        "MATTHEWS JEWELLERS KOTARA",
        "ENGAGE DANDENONG (AUSTGOLD JEWELLERY)",
        "MELBOURNE JEWELLERS",
        "STEPHENS & MILLER",
        "BAUHAUS RUNDLE STREET",
        "ASARA",
        "MARK BLYTH FINE JEWELLERY",
        "MILDURA SHOWCASE JEWELLERS",
        "MCLEAN & CO JEWELLERS"
    ]
    
    let ssfkStore = [
        "CENTRAL ART",
        "B & S LYNCRIS JEWELLERS",
        "AREZZO",
        "COSIMO JEWELLERY PTY LTD",
        "DANNY DESIGNER JEWELLER",
        "BESTOWED JEWELLERS",
        "DARLING",
        "FILIGREE JEWELLERS",
        "ASHA JEWELRY",
        "STUDIO B",
        "CAMPBELL'S JEWELLERY",
        "DIAMONDS PLUS"
    ]

    var addressesList = $('#addresses_list');
    var ulElement = addressesList.find('ul');
    var liElement = ulElement.find('li');
    var nameElement = liElement.find('.name');

    nameElement.each(function() {
        var name = $(this).text().toUpperCase();

        switch (true) {
            case ssStore.includes(name):
                $(this).closest('li').addClass('ssStore');
                break;

            case fkStore.includes(name):
                $(this).closest('li').addClass('fkStore');
                break;

            case ssfkStore.includes(name):
                $(this).closest('li').addClass('ssfkStore');
                break;
        }
    });
});

class announcementBanner extends HTMLElement {
    constructor() {
        super();
        this.delay = parseInt(this.dataset.speed)
        if(this.delay) {
            this.banner_animation_interval = setInterval(this.initAnimation.bind(this), this.delay)
        }
    }
    initAnimation() {
        const tapes = this.querySelectorAll('.js-header-tapes')
        const tape_size = tapes.length
        const last_index = tape_size - 1
        
        tapes.forEach((tape,index) => {
            let currentIndex = 0, nextIndex = 0
            if(tape.classList.contains('active')) {
                currentIndex = index
                if(currentIndex < last_index) {
                    nextIndex = currentIndex + 1
                }else if(currentIndex === last_index) {
                    nextIndex = last_index
                }else {
                    nextIndex = 0;
                }
            }
            tapes.forEach(tape => {
                tape.classList.remove('active');
            })
            console.log(nextIndex)
            tapes[nextIndex].classList.add('active');
        })
    }
}
customElements.define('announcement-banner', announcementBanner)
